import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home/Home';
import BankPage from './components/BankPage/BankPage';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:bankname" element={<BankPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
